export type Lang = "en" | "es";

export const DICT = {
 en: {
 nav: {
 browse: "Browse",
 help: "Help",
 list: "List your practice",
 login: "Log in",
 signup: "Sign up",
 dashboard: "Dashboard",
 openMenu: "Open menu",
 language: "Language",
 },
 hero: {
 badge: "AI Healthcare Finder",
 title: "Find the right healthcare provider in seconds.",
 subtitle: "Search doctors, dentists, chiropractors, and clinics by specialty, location, insurance, and availability.",
 },
 search: {
 normal: "Normal search",
 ai: "Ask Heallexa",
 whatCare: "What care do you need?",
 selectSpecialty: "Select a specialty",
 location: "Location",
 locationPh: "City or ZIP code",
 insurance: "Insurance",
 selectInsurance: "Select your insurance",
 submit: "Search",
 askPh: 'Ask Heallexa: "Find a chiropractor in Dallas that accepts Blue Cross"',
 ask: "Ask",
 voice: "Voice search",
 listening: "🎙️ Listening… speak now. We'll search automatically when you stop.",
 examples: 'Try: "Pediatrician in Los Angeles that takes Kaiser" · "Urgent care near Chicago open now" · or tap the mic to ask with your voice.',
 voiceUnsupported: "Voice search isn't supported in this browser. Try Chrome on desktop or Android.",
 },
 insuranceCarousel: { title: "Insurance accepted by providers on Heallexa" },
 asSeen: { title: "As seen on" },
 features: {
 title: "Stop giving away your practice revenue",
 subtitle: "Heallexa eliminates per-appointment fees and fragmented multi-location tech with one simple, flat-rate growth engine.",
 askTitle: "AI Patient Matching",
 askDesc: "Stop wasting hours chasing cold leads. Our smart AI routing instantly connects you with ready-to-book patients.",
 specTitle: "0% Booking Fees",
 specDesc: "Keep 100% of your clinical earnings. No per-appointment cuts, hidden penalties, or surprise invoice deductions.",
 insTitle: "Universal Location Sync",
 insDesc: "One single subscription seamlessly manages all your physical clinics, virtual telehealth branches, and staff profiles.",
 locTitle: "Practice Redefined",
 locDesc: "Launch your unified workspace in under five minutes. Zero complex data migration, total schedule control.",
 browseLink: "Claim your provider profile today →",
 },
 how: {
 title: "Healthcare booking on your terms",
 s1Title: "Text, chat, or call",
 s1Desc: "Book appointments 24/7 via text, SMS, or a quick phone call. No apps to download.",
 s2Title: "Speak your language",
 s2Desc: "Type or speak naturally in your native language. Our system translates everything instantly.",
 s3Title: "No waiting lists",
 s3Desc: "Bypass frustrating clinic phone trees. See real-time slots and claim your appointment immediately.",
 s4Title: "One-click booking",
 s4Desc: "Receive your automated confirmation text instantly. Your care is locked in with zero hassle.",
 },
 cta: {
 forPatients: "For patients",
 patientsTitle: "Find care that fits.",
 patientsDesc: "Search free. No account required.",
 patientsBtn: "Browse providers",
 forProviders: "For providers",
 providersTitle: "Get found by patients.",
 providersDesc: "List your practice free, or upgrade for premium visibility.",
 providersBtn: "List your practice",
 },
 footer: {
 tagline: "AI-powered healthcare finder. Ask. Find. Care.",
 patients: "Patients",
 home: "Home",
 browseCats: "Browse categories",
 searchLink: "Search",
 helpContact: "Help & contact",
 providers: "Providers",
 claim: "Claim your listing",
 pricing: "Pricing",
 providerLogin: "Provider login",
 rights: "All rights reserved.",
 privacy: "Privacy Policy",
 terms: "Terms of Service",
 },
 browse: {
 title: "Browse providers",
 subtitle: "Discover doctors, dentists, and clinics by specialty, city, insurance, or condition.",
 bySpec: "Browse by specialty",
 byCity: "Browse by city",
 byIns: "Browse by insurance",
 byCond: "Browse by condition",
 },
 help: {
 title: "Help & FAQ",
 subtitle: "Answers to common questions about Heallexa.",
 cant: "Can't find what you need?",
 email: "Email",
 provider: "Are you a provider?",
 list: "List your practice →",
 },
 list: {
 forProviders: "For providers",
 title: "Grow your visibility with Heallexa",
 subtitle: "Reach patients searching for care in your specialty. Claim your free listing or upgrade to Premium for priority placement.",
 },
 login: {
 signinSub: "Sign in to your Heallexa account",
 signupSub: "Create your Heallexa account",
 iAm: "I am a…",
 patient: "Patient",
 patientDesc: "Find and save providers",
 doctor: "Doctor / Practice",
 doctorDesc: "Claim & manage your listing",
 continueGoogle: "Continue with Google",
 signingIn: "Signing in…",
 or: "or",
 fullName: "Full name",
 email: "Email",
 password: "Password",
 signIn: "Sign in",
 createPatient: "Create patient account",
 createDoctor: "Create provider account",
 noAcct: "Don't have an account?",
 hasAcct: "Already have an account?",
 back: "← Back to Heallexa",
 terms: "By continuing, you agree to Heallexa's terms of service and privacy policy.",
 googleErr: "Google sign-in could not be loaded.",
 checkEmail: "Check your email to confirm your account.",
 },
 common: {
 loadingDash: "Loading your dashboard…",
 gotIt: "Got it",
 back: "Back",
 },
 filters: {
 title: "Filters",
 specialty: "Specialty",
 city: "City",
 insurance: "Insurance",
 minRating: "Minimum rating",
 any: "Any",
 verifiedOnly: "Verified only",
 premiumOnly: "Premium only",
 reset: "Reset filters",
 results: "results",
 },
 },
 es: {
 nav: {
 browse: "Explorar",
 help: "Ayuda",
 list: "Registra tu consultorio",
 login: "Iniciar sesión",
 signup: "Registrarse",
 dashboard: "Panel",
 openMenu: "Abrir menú",
 language: "Idioma",
 },
 hero: {
 badge: "Buscador médico con IA",
 title: "Encuentra al profesional médico ideal en segundos.",
 subtitle: "Busca médicos, dentistas, quiroprácticos y clínicas por especialidad, ubicación, seguro y disponibilidad.",
 },
 search: {
 normal: "Búsqueda normal",
 ai: "Pregunta a Heallexa",
 whatCare: "¿Qué atención necesitas?",
 selectSpecialty: "Selecciona una especialidad",
 location: "Ubicación",
 locationPh: "Ciudad o código postal",
 insurance: "Seguro",
 selectInsurance: "Selecciona tu seguro",
 submit: "Buscar",
 askPh: 'Pregunta a Heallexa: "Busca un quiropráctico en Dallas que acepte Blue Cross"',
 ask: "Preguntar",
 voice: "Búsqueda por voz",
 listening: "🎙️ Escuchando… habla ahora. Buscaremos automáticamente al terminar.",
 examples: 'Prueba: "Pediatra en Los Ángeles que acepte Kaiser" · "Urgencias cerca de Chicago abiertas ahora" · o toca el micrófono para preguntar con tu voz.',
 voiceUnsupported: "La búsqueda por voz no está disponible en este navegador. Prueba Chrome en escritorio o Android.",
 },
 insuranceCarousel: { title: "Seguros aceptados por profesionales en Heallexa" },
 asSeen: { title: "Visto en" },
 features: {
 title: "Deja de regalar los ingresos de tu consulta",
 subtitle: "Heallexa elimina las comisiones por cita y la tecnología fragmentada de múltiples ubicaciones con un único motor de crecimiento de tarifa plana.",
 askTitle: "Emparejamiento de pacientes con IA",
 askDesc: "Deja de perder horas persiguiendo leads fríos. Nuestro enrutamiento inteligente con IA te conecta al instante con pacientes listos para reservar.",
 specTitle: "0% de comisión por reserva",
 specDesc: "Conserva el 100% de tus ingresos clínicos. Sin descuentos por cita, penalizaciones ocultas ni deducciones sorpresa en la factura.",
 insTitle: "Sincronización universal de ubicaciones",
 insDesc: "Una sola suscripción gestiona sin problemas todas tus clínicas físicas, sucursales de telesalud virtuales y perfiles del personal.",
 locTitle: "La consulta, redefinida",
 locDesc: "Lanza tu espacio de trabajo unificado en menos de cinco minutos. Cero migración de datos compleja, control total del calendario.",
 browseLink: "Reclama hoy tu perfil de profesional →",
 },
 how: {
 title: "Reservas médicas en tus términos",
 s1Title: "Texto, chat o llamada",
 s1Desc: "Reserva citas 24/7 por mensaje, SMS o una llamada rápida. Sin apps que descargar.",
 s2Title: "Habla tu idioma",
 s2Desc: "Escribe o habla con naturalidad en tu idioma. Nuestro sistema traduce todo al instante.",
 s3Title: "Sin listas de espera",
 s3Desc: "Evita los frustrantes menús telefónicos. Ve horarios en tiempo real y reserva al momento.",
 s4Title: "Reserva con un clic",
 s4Desc: "Recibe tu confirmación automática al instante. Tu cita queda asegurada sin complicaciones.",
 },
 cta: {
 forPatients: "Para pacientes",
 patientsTitle: "Encuentra atención a tu medida.",
 patientsDesc: "Buscar es gratis. Sin necesidad de cuenta.",
 patientsBtn: "Explorar profesionales",
 forProviders: "Para profesionales",
 providersTitle: "Que los pacientes te encuentren.",
 providersDesc: "Registra tu consultorio gratis o mejora a Premium para mayor visibilidad.",
 providersBtn: "Registra tu consultorio",
 },
 footer: {
 tagline: "Buscador médico con IA. Pregunta. Encuentra. Cuídate.",
 patients: "Pacientes",
 home: "Inicio",
 browseCats: "Explorar categorías",
 searchLink: "Buscar",
 helpContact: "Ayuda y contacto",
 providers: "Profesionales",
 claim: "Reclama tu ficha",
 pricing: "Precios",
 providerLogin: "Acceso profesionales",
 rights: "Todos los derechos reservados.",
 privacy: "Política de privacidad",
 terms: "Términos del servicio",
 },
 browse: {
 title: "Explorar profesionales",
 subtitle: "Descubre médicos, dentistas y clínicas por especialidad, ciudad, seguro o condición.",
 bySpec: "Por especialidad",
 byCity: "Por ciudad",
 byIns: "Por seguro",
 byCond: "Por condición",
 },
 help: {
 title: "Ayuda y preguntas frecuentes",
 subtitle: "Respuestas a las preguntas más comunes sobre Heallexa.",
 cant: "¿No encuentras lo que necesitas?",
 email: "Correo",
 provider: "¿Eres profesional?",
 list: "Registra tu consultorio →",
 },
 list: {
 forProviders: "Para profesionales",
 title: "Aumenta tu visibilidad con Heallexa",
 subtitle: "Llega a pacientes que buscan atención en tu especialidad. Reclama tu ficha gratis o pásate a Premium para destacar.",
 },
 login: {
 signinSub: "Inicia sesión en tu cuenta de Heallexa",
 signupSub: "Crea tu cuenta de Heallexa",
 iAm: "Soy…",
 patient: "Paciente",
 patientDesc: "Encuentra y guarda profesionales",
 doctor: "Médico / Consultorio",
 doctorDesc: "Reclama y gestiona tu ficha",
 continueGoogle: "Continuar con Google",
 signingIn: "Iniciando sesión…",
 or: "o",
 fullName: "Nombre completo",
 email: "Correo",
 password: "Contraseña",
 signIn: "Iniciar sesión",
 createPatient: "Crear cuenta de paciente",
 createDoctor: "Crear cuenta profesional",
 noAcct: "¿No tienes cuenta?",
 hasAcct: "¿Ya tienes cuenta?",
 back: "← Volver a Heallexa",
 terms: "Al continuar, aceptas los términos y la política de privacidad de Heallexa.",
 googleErr: "No se pudo cargar el inicio de sesión con Google.",
 checkEmail: "Revisa tu correo para confirmar tu cuenta.",
 },
 common: {
 loadingDash: "Cargando tu panel…",
 gotIt: "Entendido",
 back: "Atrás",
 },
 filters: {
 title: "Filtros",
 specialty: "Especialidad",
 city: "Ciudad",
 insurance: "Seguro",
 minRating: "Calificación mínima",
 any: "Cualquiera",
 verifiedOnly: "Solo verificados",
 premiumOnly: "Solo Premium",
 reset: "Restablecer filtros",
 results: "resultados",
 },
 },
} as const;

type DeepStringify<T> = {
 [K in keyof T]: T[K] extends object ? DeepStringify<T[K]> : string;
};
export type Dict = DeepStringify<typeof DICT["en"]>;
